import { atom } from "jotai";

const initialLayerOpacity = Number(process.env.REACT_APP_INITIAL_LAYER_OPACITY || 0.8);
export const layerOpacityAtom = atom(initialLayerOpacity);
